<template>
    <div>
        <CRow>
            <CCol md="12">
                <CForm>

                    <CCard>
                        <CCardHeader>
                            <strong>{{selectedTypeReturnLabel}}</strong>
                        </CCardHeader>
                        <CCardBody>

                            <CRow>

                                <CCol sm="6" md="4">
                                    <div>
                                        <date-picker v-model="date"></date-picker>
                                    </div>
                                </CCol>

                                <CCol sm="6" md="4">
                                    <CRow>
                                        <CCol sm="12">
                                            {{document_person_name}}

                                        </CCol>
                                    </CRow>


                                </CCol>
                                <CCol sm="6" md="4">
                                    <select v-model="selected_place" class="form-control"

                                    >
                                        <option value="0">
                                          {{$t('components.selectWarehouse')}}
                                        </option>
                                        <option v-for="option in places_items" v-bind:value="option.id">
                                            {{ option.placeName }}
                                        </option>
                                    </select>

                                </CCol>
                            </CRow>
                            <CTextarea
                                :label="$t('components.documentSummary')"

                                    v-model="document_summary"

                                    rows="4"
                            />
                        </CCardBody>

                    </CCard>
                    <CCard>
                        <CCardHeader>
                            <strong>{{$t('components.documentProducts')}}</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="12">
                                    {{product_name}}
                                </CCol>
                            </CRow>
                            <CRow>


                            </CRow>
                            <label>{{ $t('components.productUnit') }}</label>
                          <CRow>
                                <CCol sm="6" md="4">

                                    {{product_unit}}


                                </CCol>
                                <CCol sm="6" md="4">

                                    <CInput
                                        :label="$t('components.productQty')"
                                            type="number"
                      v-on:keypress="isNumber($event)"
                                            v-model="product_count"
                                    />
                                </CCol>
                                <label>{{ $t('components.unitPrice') }} {{product_price}}</label>


                          </CRow>
                            <p>{{product_summary}}</p>


                            <CButton v-if="status_form!=0" @click="add_product_to_document()" size="sm"
                                     color="primary">
                                <CIcon name="cil-check-circle"/>
                              {{$t('buttons.editProduct')}}

                            </CButton>


                            <CDataTable
                                    :items="product_items"
                                    :fields="product_fields"

                                    :items-per-page="200"
                                    hover
                                    sorter
                                    pagination
                            >
                                <template #row="{item}">

                                    <td>
                                        <p >{{item.row_id+1}}</p>

                                    </td>

                                </template>
                                <template #name="{item}">

                                    <td>
                                        <p >{{item.productName}}</p>

                                    </td>

                                </template>

                                <template #unit="{item}">

                                    <td>
                                        <p >{{item.productUnitName}}</p>

                                    </td>

                                </template>

                                <template #qty="{item}">

                                    <td>
                                        <p >{{item.qty}}</p>

                                    </td>

                                </template>
                                <template #price="{item}">

                                    <td>
                                        <p >
                                            {{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")}}</p>

                                    </td>

                                </template>
                                <template #totalPrice="{item}">

                                    <td>
                                        <p >
                                            {{(item.price*item.qty).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                            ",")}}</p>

                                    </td>

                                </template>
                                <template #summary="{item}">

                                    <td>
                                        <p >{{item.summary}}</p>

                                    </td>

                                </template>


                                <template #operation="{item}">
                                    <td >
                                        <CButton
                                                color="primary"
                                                variant="outline"
                                                square
                                                size="sm"
                                                @click="edit_item(item,index)"
                                        >{{$t('buttons.edit')}}
                                        </CButton>
                                        <CButton
                                                color="danger"
                                                variant="outline"
                                                square
                                                size="sm"
                                                @click="delete_item_dialog(item)"
                                        >{{$t('buttons.delete')}}

                                        </CButton>
                                    </td>
                                </template>


                            </CDataTable>

                            <CRow v-if="1==0">

                                <CCol sm="6" md="4">

                                    <CInput
                                        :label="$t('components.offPercent')"
                                            type="number"
                      v-on:keypress="isNumber($event)"
                                            v-model="product_off"
                                    />
                                </CCol>
                                <CCol sm="6" md="4">

                                    <CInput
                                        :label="$t('components.taxPercent')"
                                            type="number"
                      v-on:keypress="isNumber($event)"
                                            v-model="product_tax"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>

                                <CCol sm="12" md="12">
                                  <p>{{$t('components.documentTotalPrice')}}</p>
                                    <p>{{total_price}}</p>
                                    <p>{{ VUE_APP_Currency }}</p>

                                </CCol>

                            </CRow>
                        </CCardBody>
                        <CCardFooter>
                            <CButton @click="insert_data_factor()" size="sm"
                                     color="primary">
                                <CIcon name="cil-check-circle"/>
                              {{$t('buttons.addDocument')}}
                            </CButton>

                        </CCardFooter>
                    </CCard>
                </CForm>

            </CCol>
        </CRow>
        <CRow>

        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Vue from "vue";

    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    var product_items = [];


    export default {
        name: 'Login',
        components: {

        },
        data() {
            return {
              VUE_APP_Currency:localStorage.getItem('currency'),

              date: '',
                product_items: product_items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                product_items_original: product_items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                 product_fields : [
                    {key: 'row',label:this.$t('tables.row'), _style: 'width:10%'},
                    {key: 'name',label:this.$t('tables.name'), _style: 'width:10%'},
                    {key: 'unit',label:this.$t('tables.unit'), _style: 'width:10%'},
                    {key: 'qty',label:this.$t('tables.qty'), _style: 'width:10%;'},
                    {key: 'price', label:this.$t('tables.price'),_style: 'width:10%;'},
                    {key: 'totalPrice',label:this.$t('tables.totalPrice'), _style: 'width:10%;'},
                    {key: 'summary',label:this.$t('tables.summary'), _style: 'width:10%;'},
                    {key: 'operation',label:this.$t('tables.operation'), _style: 'width:20%;'},


                ],

                selectedType: '1',
                selectedTypeReturn: '1',
                selectedTypeReturnLabel: '1',
                selectedTypeQty: 1,
                selectedTypeLabel: this.$t('components.seller'),

                document_person_name: "",
                document_person: null,
                document_summary: '',


                product_name: '',
                product_count: '',
                product_unit: '',
                product_unit_id: '',
                product_summary: '',
                product_price: '',
                product_off: 0,
                product_tax: 0,


                total_price: 0,
                details: [],
                permission_group_items: [],
                selected_permission_group: 0,

                places_items: [],
                unit_items: [],
                unit_items_filtered: [],
                selected_place: 0,
                selected_product: null,

                status_form: 0,
                master_id: 0,
                load_products({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.productCodeName,
                    }
                },


            }
        }, mounted() {
            this.$root.root_validate_errors = [];

            this.get_document_master();
            this.get_document_details();
            this.get_places();
            this.get_product_units();


            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                  this.status_product_form = -1;
                }
            });
            bus.$on('update_price', (data) => {
                // alert(data);
                if (data == "true") {
                    this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

                } else {
                    this.status_form = 0;
                }
            });

            if (this.$route.params.user_id != null) {
                this.status_form = this.$route.params.user_id;
                this.get_user_data();
            }
        }, watch: {
            'selectedType': function () {
                if (this.selectedType == 1) {
                    this.selectedTypeLabel = this.$t('components.seller');
                    this.selectedTypeReturn = 2;
                    this.selectedTypeReturnLabel =this.$t('components.documentBuyRet') ;
                    this.selectedTypeQty = 1;
                }
                if (this.selectedType == 3) {
                    this.selectedTypeLabel = this.$t('components.buyer');
                    this.selectedTypeReturn = 4;
                    this.selectedTypeReturnLabel = this.$t('components.documentSellRet');
                    this.selectedTypeQty = -1;

                }
                if (this.selectedType == 5) {
                    this.selectedTypeLabel = this.$t('components.employee');
                    this.selectedTypeQty = 1;
                    this.selectedTypeReturn = 6;
                    this.selectedTypeReturnLabel =this.$t('components.documentFirstRet');
                }
            },

            'selected_product': function () {
                this.get_product_data()
            },
            'product_items': function () {
                this.total_price = 0;
                var off = 0;
                var tax = 0;
                this.product_items.forEach((val) => {
                    this.total_price += (val.count * val.price * val.unit_value);

                });
                off = this.product_off;
                tax = this.product_tax;
                var off_price = (this.total_price * off) / 100;
                var tax_price = (this.total_price * tax) / 100;
                this.total_price = this.total_price - off_price - tax_price;
                this.total_price = this.get_currency(this.total_price);
            },

        },
        methods: {
            get_document_master() {
                var self = this;

                const formData = new FormData();

                var url = "GetRecById";

                formData.append("id", this.$route.params.doc_id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
                        self.selectedType = content_data.data.docType;
                        self.document_person_name = content_data.data.partyName;
                        self.document_person = content_data.data.partyId;
                        self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
                        // self.selected_place = content_data.data.placeName;
                        self.document_summary = content_data.data.docDesc;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_document_details() {
                var self = this;

                const formData = new FormData();

                var url = "GetDocItemsByDocId_New";

                formData.append("id", this.$route.params.doc_id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.product_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });

                        self.product_items_original = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });
                        if (self.$route.params.return_driver) {

                            self.product_items.forEach((val) => {
                                val.qty = 0;

                            });
                        }
                        console.log("return driver "+self.$route.params.return_driver);
                        if (self.$route.params.return_driver) {
                            self.get_document_deriver_return();
                        }
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_document_deriver_return() {
                var self = this;

                const formData = new FormData();

                var url = "GetProductRetsByMasterId";

                formData.append("id", this.$route.params.doc_id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {


                        self.product_items.forEach((val) => {
                           // val.qty = 0;

                            content_data.data.forEach((val2) => {
                                // val.qty = 0;
if(val.productId==val2.productId){
    val.qty = val2.qty;
}
                            });
                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


            get_product_data() {

                let self = this;
                const formData = new FormData();
                let url;
                url = "GetProductById";

                formData.append('id', this.selected_product);
              formData.append('PersonId', this.document_person);
                axios.post(url, formData, {}).then((res) => {


                    self.product_name = res.data.data.productName;
                    self.product_price = res.data.data.salePrice;

                    //self.unit_items_filtered =  self.unit_items.filter(item => item.id==res.data.data.productUnitId);
                    // var row_index = 0;
                    self.unit_items_filtered = [];
                    var base_id = 0;
                    self.unit_items.forEach((val) => {
                        if (val.id == res.data.data.productUnitId) {
                            self.unit_items_filtered.push(val);
                            self.product_unit = val.id;
                            base_id = val.baseUnitId;
                        }
                        // val.row_id = row_index;
                        // row_index += 1;

                    });
                    self.unit_items.forEach((val) => {
                        if (val.id == base_id) {
                            self.unit_items_filtered.push(val);
                            // self.product_unit = val.id;
                            // base_id = val.baseUnitId;
                        }
                        // val.row_id = row_index;
                        // row_index += 1;

                    });
                    self.unit_items_filtered.forEach((val) => {
                        if (val.id == res.data.data.productUnitId) {
                            self.product_unit = val.id;
                        }

                    });


                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },

            validateForm: function () {


                this.$root.root_validate_errors = [];


                if ( this.selected_place != 0) {
                    return true;


                }

                if (this.selected_place == 0) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.selectWarehouse'));
                }
                // if (this.document_person == null) {
                //     this.$root.root_validate_errors.push(this.selectedTypeLabel + ' را انتخاب کنید');
                // }
                // if (this.this.product_items.length == 0) {
                //     this.$root.root_validate_errors.push('یک یا چند کالا را انتخاب کنید');
                // }

                return false;
                // e.preventDefault();
            },
            validateProduct: function () {

                var index_list = 0;
                var index_i = 0;
                this.product_items.forEach((val) => {
                    if (val.productId == this.status_form) {
                        index_list = index_i;
                    }
                    // val.row_id = row_index;
                    index_i += 1;

                });


                this.$root.root_validate_errors = [];


                if (this.product_count != '' && this.product_count<=this.product_items_original[index_list].qty ) {
                    return true;


                }

                if (this.product_count>this.product_items_original[index_list].qty) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.qtyMustBeLowerThanMainQty') );
                }
                if (this.product_count == '' ) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
                }



                return false;
                // e.preventDefault();
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            add_product_to_document() {
                if (this.validateProduct()) {

                 var index_list = 0;
                 var index_i = 0;
                    this.product_items.forEach((val) => {
                        if (val.productId == this.status_form) {
                            index_list = index_i;
                        }
                        // val.row_id = row_index;
                        index_i += 1;

                    });
                  // this.product_items[this.status_form]. =   this.product_name = item.productName;
                  //   this.product_unit = item.productUnitName;
                  //   this.product_unit_id = item.productUnitId;
                    this.product_items[index_list].qty =  this.product_count ;
                    // this.product_price = item.price;
                    // this.status_form = item.productId;
                    this.status_form = 0;
                    // this.product_summary = item.docDesc;

                    var product_new_item = [];
                    // this.unit_items.forEach((val) => {
                    //     if (val.id == this.product_unit) {
                    //         product_new_item.unit_value = val.value;
                    //     }
                    //     // val.row_id = row_index;
                    //     // row_index += 1;
                    //
                    // });
                    // product_new_item.name = this.product_name;
                    // product_new_item.unit = this.product_unit;
                    // product_new_item.count = this.product_count;
                    // product_new_item.price = this.product_price;
                    // product_new_item.summary = this.product_summary;
                    // product_new_item.product_id = this.selected_product;
                    // this.product_items.push(product_new_item);
                    this.product_name = "";
                    this.product_unit = "";
                    this.product_count = "";
                    this.product_summary = '';
                    this.product_price = 0;
                    // var row_index = 0;
                    // this.product_items.forEach((val) => {
                    //     val.row_id = row_index;
                    //     row_index += 1;
                    //
                    // });
                }
            },
            edit_item(item,index) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.product_name = item.productName;
                this.product_unit = item.productUnitName;
                this.product_unit_id = item.productUnitId;
                this.product_count = item.qty;
                this.product_price = item.price;
                this.status_form = item.productId;
                // this.status_form = index;
                this.product_summary = item.docDesc;
console.log("status form is "+index);
                // this.product_name = "";
                // this.product_unit = "";
                // this.product_count = "";
                // this.product_summary = '';
                // this.product_price = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                if (this.status_form != 0) {
                    this.$router.push({path: '/dashboard/products/list'})
                } else {
                    this.status_form = 0;
                    this.name = '';
                    this.color = '';
                    this.description = '';
                    this.previewImage = '';
                    this.weight = '';
                    this.selected_unit = '0';
                    this.selected_brand = '0';
                    this.selected_category = '0';
                    this.barcode = '';
                }

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },

            get_places() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetPlaces', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.places_items = content_data.data;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_product_units() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetProductUnits', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.unit_items = content_data.data;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            insert_data_factor() {
                if (!this.validateForm()) {
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;

                // if (this.status_form == 0) {
                    url = "AddFactor";
                // } else {
                //     url = "EditFactorMaster";
                //     formData.append('PersonId', this.status_form)
                //
                // }

                // StatusId
                // DocDesc
                // Id
                // CreatedBy
                // BaseFactorId
                //
                formData.append('BaseFactorId', this.$route.params.doc_id);
                formData.append('DocDate', this.date);
                formData.append('PartyId', this.document_person);
                formData.append('PlaceId', this.selected_place);
                formData.append('DocType', this.selectedTypeReturn);
                formData.append('DocDesc', this.document_summary);
                axios.post(url, formData, {}).then((res) => {



                    // self.get_lists();
                    self.$root.modal_component.show_api_response_modals(res);
                    if (self.status_form == 0) {

                        self.master_id = res.data.data.id;
                        var index = 0;
                        self.insert_factor_products(index);

                        // self.product_items.forEach((val) => {
                        //     self.insert_factor_products(index);
                        //     index+=1;
                        //
                        // });

                    } else {
                        // this.$router.push({path:'/dashboard/products/list'})

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            }
            , insert_factor_products(index) {

                let self = this;
                const formData = new FormData();
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorDetail";
                // } else {
                //     url = "EditPerson";
                //     formData.append('PersonId', this.status_form)
                //
                // }
                // AddFactorDetail
                // GetDetailRecById
                // EditFactorDetail
                // DeleteFactorDetail
                //     MasterId
                //     PlaceId
                //     ProductId
                //     ProductUnitId
                //     Qty
                //     Price
                //     DocDesc
                formData.append('MasterId', this.master_id);
                formData.append('PlaceId', this.selected_place);
                formData.append('ProductId', this.product_items[index].productId);
                formData.append('ProductUnitId', this.product_items[index].productUnitId);
                formData.append('Qty', this.product_items[index].qty * this.selectedTypeQty);
                formData.append('Price', this.product_items[index].price);
                formData.append('ProductDesc', this.product_items[index].docDesc);

                // formData.append('Color', this.color);
                // formData.append('description', this.description);
                axios.post(url, formData, {}).then((res) => {



                    // self.get_lists();
                    self.$root.modal_component.show_api_response_modals(res);
                    if (self.status_form == 0) {
                        self.date = "";
                        self.document_person = null;
                        self.document_summary = "";
                        if (index == self.product_items.length - 1) {
                            self.product_items = [];
                            self.selected_place = 0;

                            self.name = "";
                            self.meli_code = "";
                            self.meli_code = "";
                            self.mobile = "";
                            self.phone_no = "";
                            self.isWorker = false;
                            self.isCustomer = false;
                            self.isVendor = false;
                            self.selected_province = 0;
                            self.selected_city = 0;
                            self.selected_area = 0;
                            self.address = "";
                            self.password = "";
                            self.selected_permission_group = 0;
                            self.user_location_lat = 0;
                            self.user_location_lng = 0;
                            self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
                        } else {
                            // this.$router.push({path:'/dashboard/products/list'})
                            self.insert_factor_products(index + 1);

                        }
                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            }

            , delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.row_id;

            },
            delete_item() {

                this.product_items.splice(this.status_form, 1);
                var row_index = 0;
                this.product_items.forEach((val) => {
                    val.row_id = row_index;
                    row_index += 1;

                });
              this.product_name = "";
              this.product_unit = "";
              this.product_count = "";
              this.product_summary = '';
              this.product_price = 0;
              this.selected_product = null;

              this.status_product_form = -1;



            },
        }
    }

</script>
